import apiClient from '../client';
import $U from '../urls';

export const fetchOrders = (page = 1) => {
  const params = { page };

  return apiClient.request('GET', $U.ORDERS, params);
};

export const searchOrder = orderNumber => {
  return apiClient.request('GET', `${$U.ORDERS}${orderNumber}/`);
};

export const fetchCancellationReasons = () => {
  return apiClient.request('GET', $U.CANCELLATION_REASONS);
};

export const sendCancelRequest = (orderItemId, reason) => {
  const data = {
    order_item: orderItemId,
    reason: reason.id,
    cancellation_type: reason.type,
    description: reason.description || '',
  };

  return apiClient.request('POST', $U.CANCELLATION_REQUEST, data);
};

export const sendCancelRequestIban = (orderItemId, reason) => {
  const data = {
    order_item: orderItemId,
    reason: reason.id,
    cancellation_type: reason.type,
    description: reason.description || '',
    iban: reason.iban,
    holder_name: reason.holder_name,
  };

  return apiClient.request('POST', $U.CANCELLATION_REQUEST, data);
};

export const sendAutoCancelRequest = (orderNumber, orderItemId, reason) => {
  const data = {
    cancel_order_items: [
      {
        order_item: orderItemId,
        reason: reason.id,
        cancellation_type: reason.type,
        description: reason.description || '',
      }
    ]
  };

  return apiClient.request(
    'POST',
    $U.AUTO_CANCELLATION_REQUEST.replace('$0', orderNumber),
    JSON.stringify(data),
    {
      dataType: 'json',
      contentType: 'application/json'
    }
  );
};
